import { InputLabel, MenuItem } from '@mui/material';
import { memo, useEffect, useMemo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';

interface ValoreDominioConsolatiVO {
  key?: { codice?: string };
  codiceStatoEstero?: string;
  denomStatoEsteroConsolato?: string;
  sedeConsolato?: string;
  rangoConsolato?: string;
  indirizzoConsolato?: string;
}

interface ListConsulateProps {
  disabled?: boolean;
  required?: boolean;
  value?: ItemVM;
  onChange: (value?: ItemVM) => void;
  error?: boolean;
  isSmallSize?: boolean;
  codiceMae?: string;
}

const ListConsulateComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  isSmallSize = false,
  codiceMae,
}: ListConsulateProps): React.ReactElement => {
  const [consulates, getConsulates] = useHttpFetch<
    HttpResponse<Array<ValoreDominioConsolatiVO>>,
    Array<ItemVM>
  >(`${__ACT_API_URL__}/filtri/dominio/97/codiceMae/${codiceMae}`, {
    onBootstrap: false,
    options: {
      errorCatching: true,
      method: 'GET',
      loading: true,
    },
    transformer: (response) =>
      ((response.data.payload || []) as Array<ValoreDominioConsolatiVO>).map((item) => ({
        id: item.key?.codice,
        value: item.sedeConsolato,
      })) as Array<ItemVM>,
  });

  useEffect(() => {
    if (codiceMae) {
      getConsulates();
    }
  }, [codiceMae]);

  const disabledComponent = useMemo(() => {
    return disabled || !codiceMae;
  }, [disabled, codiceMae]);

  const consulatesData: Array<ItemVM> = useMemo(() => {
    return (consulates.data || []) as Array<ItemVM>;
  }, [consulates.data]);

  const consulatesDataDisabled: Array<ItemVM> | undefined = useMemo(() => {
    if (codiceMae || !value?.id) {
      return undefined;
    }

    return [value];
  }, [value, codiceMae]);

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabledComponent} id="consulate-label">
        {required ? 'Anagrafica consolato *' : 'Anagrafica consolato'}
      </InputLabel>
      <PmiSelect
        labelId="consulate-label"
        id="consulate"
        name="consulate"
        value={value?.id || ''}
        label={required ? 'Anagrafica consolato *' : 'Anagrafica consolato'}
        onChange={(event) =>
          onChange(consulatesData?.find((item) => item.id === event.target.value))
        }
        disabled={disabledComponent}
        error={error}
        size={isSmallSize ? 'small' : undefined}
      >
        {(consulatesDataDisabled || consulatesData)?.map((consulate: ItemVM) => (
          <MenuItem key={consulate.id} value={consulate.id}>
            {consulate.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListConsulateComponent.displayName = 'List consulate Document component';

const ListConsulate = memo(ListConsulateComponent);

export default ListConsulate as typeof ListConsulateComponent;
